import httpClient from '@/services/http.js'

class FileUploadService {

  constructor() {
    // this.baseURL = 'https://us-central1-showroom-241012.cloudfunctions.net/UploadResize'
    this.baseURL = 'https://us-central1-simply-studio.cloudfunctions.net'
  }
  
  async galleryUpload(projectname, file, uploadProgressCallback) {
    let formData = new FormData()
    formData.append('projectName', projectname)
    formData.append('uploadType', 'gallery')
    formData.append('files', file)

    const config = {
      onUploadProgress: (progressEvent) => uploadProgressCallback(progressEvent),
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    }

    await httpClient.post(
      this.baseURL + '/UploadResize',
      formData, 
      config
    )
    .catch(err => this.err = err)
  }

  async rotateImage(projectname, filename, section, degrees = 90) {
    return httpClient.post(
      this.baseURL + '/RotateImage',
      {
        projectname: projectname,
        filename: filename,
        degrees: degrees,
        section: section
      },
    ).then(res => res.data)
  }

  async rotateGalleryImage(projectName, filename, degrees = 90) {
    return this.rotateImage(projectName, filename, 'gallery', degrees)
  }
  
  async rotateCustomRoom(projectName, filename, degrees = 90) {
    return this.rotateImage(projectName, filename, 'rooms', degrees)
  }

  async deleteImage(projectname, filename, section) {
    return httpClient.post(
      this.baseURL + '/DeleteImage',
      {
        projectname: projectname,
        filename: filename,
        section: section
      }
    ).then(res => res.data)
  }

  async deleteGalleryImage(projectname, filename) {
    return this.deleteImage(projectname, filename, 'gallery')
  }

  async deleteCustomRoom(projectname, filename) {
    return this.deleteImage(projectname, filename, 'rooms')
  }
}

let fileUploadService = new FileUploadService()

export default fileUploadService